import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  flatlistContainer : {
    flex: 1
  }
});

export default styles;
